import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@components/Modal";
import ContactCard from "./ContactCard";
import { ServiceHoursFooter } from "./ServiceHoursFooter";
import {
  CONTACT_CHANNELS,
  SERVICE_HOURS,
  WHATSAPP_GREEN,
} from "../../constants/contactChannels.constants";

interface ContactChannelsModalProps {
  open: boolean;
  onClose: () => void;
}

const ContactChannelsModal: React.FC<ContactChannelsModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onCloseCallback={onClose}
      hiddenButton={true}
      iconClose={false}
      maxWidth="98vw"
      aria-labelledby="contact-channels-modal-title"
      aria-describedby="contact-channels-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { xs: "95vw", sm: "80vw", md: "50vw", lg: "40vw" },
          maxWidth: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          paddingX: 1,
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2.5,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              gap: 1.5,
            }}
          >
            <WhatsAppIcon sx={{ fontSize: 25, color: WHATSAPP_GREEN }} />

            <Typography
              id="contact-channels-modal-title"
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1.8rem", md: "2rem" },
                color: "text.primary",
              }}
            >
              Fale pelo WhatsApp
            </Typography>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton onClick={onClose} size="small" aria-label="Fechar">
              <CloseIcon sx={{ fontSize: 22, color: "#58595B" }} />
            </IconButton>
          </Box>
        </Box>

        <Typography
          id="contact-channels-modal-description"
          variant="body2"
          sx={visuallyHidden}
        >
          Lista de canais de atendimento via WhatsApp com horários de
          funcionamento
        </Typography>

        {CONTACT_CHANNELS.length === 0 ? (
          <Typography
            variant="body1"
            sx={{
              fontSize: "1.4rem",
              color: "#58595B",
              textAlign: "left",
              padding: 2,
            }}
          >
            Nenhum canal disponível no momento
          </Typography>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              width: "100%",
            }}
          >
            {CONTACT_CHANNELS.map((channel) => (
              <ContactCard key={channel.id} channel={channel} />
            ))}
          </Box>
        )}

        <ServiceHoursFooter hours={SERVICE_HOURS} />
      </Box>
    </Modal>
  );
};

export default ContactChannelsModal;
